export * from './lib/UiKitTextCopy';
